// test819
(819 && 0);
